<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <p class="hint">Drag the box over the {{ mode === 'vin' ? 'VIN' : 'plate number' }} — it's the biggest
    thing you can do to make the scan accurate. Leave a little space around the text; a box that clips
    the first or last character will read wrong without warning.</p>

  <div class="stage"
       (pointermove)="onDrag($event)"
       (pointerup)="endDrag()"
       (pointercancel)="endDrag()"
       (pointerleave)="endDrag()">
    <img #photo [src]="previewUrl" alt="Photo to crop" draggable="false">

    <!-- Dim everything the scan will discard: four rects around the box, rather
         than one shape with a hole, which depends on clip-path winding rules. -->
    <div class="shade" [style.left.%]="0" [style.top.%]="0" [style.right.%]="0"
         [style.height.%]="box.top * 100"></div>
    <div class="shade" [style.left.%]="0" [style.top.%]="box.bottom * 100" [style.right.%]="0"
         [style.bottom.%]="0"></div>
    <div class="shade" [style.left.%]="0" [style.top.%]="box.top * 100"
         [style.width.%]="box.left * 100" [style.height.%]="(box.bottom - box.top) * 100"></div>
    <div class="shade" [style.left.%]="box.right * 100" [style.top.%]="box.top * 100"
         [style.right.%]="0" [style.height.%]="(box.bottom - box.top) * 100"></div>

    <div class="crop-box"
         [style.left.%]="box.left * 100"
         [style.top.%]="box.top * 100"
         [style.width.%]="(box.right - box.left) * 100"
         [style.height.%]="(box.bottom - box.top) * 100"
         (pointerdown)="startDrag($event, 'move')">
      <span class="handle nw" (pointerdown)="startDrag($event, 'nw')"></span>
      <span class="handle ne" (pointerdown)="startDrag($event, 'ne')"></span>
      <span class="handle sw" (pointerdown)="startDrag($event, 'sw')"></span>
      <span class="handle se" (pointerdown)="startDrag($event, 'se')"></span>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-link" (click)="useWholePhoto()">Scan whole photo</button>
  <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="confirm()">Scan</button>
</div>
